<template>
  <div class="full-routes project-roles">
    <bread-icon class="icon"></bread-icon>
    <trim-item :string="link.name"
               class="name"
               :width="25"></trim-item>
  </div>
</template>

<script>
  import {breadcrumbsMixin} from "../../../../mixins/sidebar/breadcrumbsMixin";
  import trimItem from '../../../trimITem'
  import {mapState} from 'vuex'

  export default {
    name: 'projectRoles',
    mixins: [breadcrumbsMixin],
    components: {
      trimItem
    },
    computed: {
      ...mapState({
        projects:  state => state.projects.allProjects
      }),
      link() {
        let projects = this.projects;
        let id = this.$route.params.id;
        for (let project of projects) {
          if (project.id == id) {
            return project
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .name {
    max-width: 60%;
  }

  .project-roles {
    max-width: 70%;
  }

  svg {
    min-width: 20px;
  }
</style>
